import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Chat from "@/pages/Chat";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Admin from "@/pages/Admin";
import AdminAgents from "@/pages/AdminAgents";
import AdminEvaluation from "@/pages/AdminEvaluation";
import AdminAnalytics from "@/pages/AdminAnalytics";
import HBMConsult from "@/pages/HBMConsult";
import HBMSocialWorkspace from "@/pages/HBMSocialWorkspace";
import PredictMarketsWorkspace from "@/pages/PredictMarketsWorkspace";
import PublicConsultShare from "@/pages/PublicConsultShare";
import VoiceMode from "@/pages/VoiceMode";
import InvestorDashboard from "@/pages/InvestorDashboard";
import MetricsPage from "@/pages/MetricsPage";
import AccountApiKeys from "@/pages/AccountApiKeys";
import AccountUsage from "@/pages/AccountUsage";
import Billing from "@/pages/Billing";
import MemorySettings from "@/pages/MemorySettings";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import ForgotPassword from "@/pages/ForgotPassword";
import PublicShare from "@/pages/PublicShare";
import usePageTracking from "@/hooks/usePageTracking";

function PageTracker() {
  usePageTracking();
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PageTracker />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/agents" element={<AdminAgents />} />
          <Route path="/admin/evaluation" element={<AdminEvaluation />} />
          <Route path="/admin/analytics" element={<AdminAnalytics />} />
          <Route path="/admin/hbm-consult" element={<HBMConsult />} />
          <Route path="/hbm" element={<HBMSocialWorkspace />} />
          <Route path="/admin/predict-markets" element={<PredictMarketsWorkspace />} />
          <Route path="/consult/share/:shareId" element={<PublicConsultShare />} />
          <Route path="/voice" element={<VoiceMode />} />
          <Route path="/investors" element={<InvestorDashboard />} />
          <Route path="/metrics" element={<MetricsPage />} />
          <Route path="/account/api-keys" element={<AccountApiKeys />} />
          <Route path="/account/usage" element={<AccountUsage />} />
          <Route path="/account/billing" element={<Billing />} />
          <Route path="/settings/memory" element={<MemorySettings />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/s/:token" element={<PublicShare />} />
          <Route path="/" element={<Chat />} />
        </Routes>
      </AuthProvider>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: "12px",
            background: "#1c1917",
            color: "#e7e5e4",
            border: "1px solid #44403c",
            borderRadius: "0.25rem",
          },
        }}
      />
    </BrowserRouter>
  );
}

export default App;
